export default {
  mosEmailSettings: null,
  chainData: null,
  offerData: null,
};
